export default "__VITE_ASSET__DTMeHcg6__"